import * as d3 from 'd3';
import * as d3ease from 'd3-ease';
import {select as d3Select} from 'd3-selection';
import { useLayoutEffect } from 'react';
// Custom hooks
import usePrevious from './usePrevious';
import useAnimated from './useAnimated';
// Constants
import * as constants from './constants';

const arcPathGenerator = d3.arc();

const NodeVisible = ({ person, person_is_noteworthy, radius, radius_off_screen, fill, animating, selected_person_change, initial_animation_delay }) => {

  // Node
  const radius_popout = (person_is_noteworthy) ? 3 : 0;
  const new_d_visible = arcPathGenerator({
    innerRadius: radius - constants.NODE_THICKNESS,
    outerRadius: radius + radius_popout,
    startAngle: person.start_angle,
    endAngle: person.end_angle,
  });

  // See if angles have changed
  const angles = `${person.start_angle} ${person.end_angle}`;
  const prev_angles = usePrevious(angles);

  // This component has animations but the length of the animation (or
  // whether we animate at all) depends on what changed. Use duration 0
  // for no animation.
  let duration;
  if (prev_angles === angles) {
    // Don't animate this change since it's just that
    // person_is_noteworthy has changed
    duration = 0;
  } else {
    // Animate: fast if selected person changed, slow otherwise (i.e. a reordering)
    duration = selected_person_change ? constants.SELECTION_ANIM_DURATION : constants.REORDER_ANIM_DURATION;
  }

  const [node_ref, {d}] = useAnimated({
    attrs : {'d' : new_d_visible},
    duration,
    deps : [new_d_visible],
    on_start : () => {animating.current = true;},
    on_stop : () => {animating.current = false;}
  });

  // Initial animation
  useLayoutEffect(() => {
    const d_init = arcPathGenerator({
      innerRadius: radius_off_screen,
      outerRadius: radius_off_screen + constants.NODE_THICKNESS + radius_popout,
      startAngle: person.start_angle,
      endAngle: person.end_angle,
    });
    d3Select(node_ref.current)
      .attr('d', d_init)
      .transition()
      .duration(constants.NODELABEL_INITIAL_ANIM_DURATION)
      .delay(initial_animation_delay * constants.NODELABEL_INITIAL_ANIM_DELAY_RANGE)
      .ease(d3ease.easeBackOut)
      .attr('d', d)
    }, []);

  return (
    <path key={`visible_${person.person_index}`}
          className="node_visible"
          ref={node_ref}
          data-person_index={person.person_index}
          d={d}
          fill={fill}/>
  );
};

export default NodeVisible;
